module.exports = __webpack_public_path__ + "media/reimu.3f594bde.mp3";